import axios from 'axios';
import { generateUrl, getAccessToken, redirectPermission } from '../helper';
const mock = axios.create({
    baseURL: generateUrl('mock-interview'),
});

mock.interceptors.request.use(
    function (config) {
        let token = getAccessToken;
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

mock.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response.status === 403) redirectPermission();
        return Promise.reject(error);
    }
);

export default mock;
